module.exports = __webpack_public_path__ + "d64f9dd8e26fdf2ce3889c35ddaa7512.svg";